import { Link } from 'react-router-dom';

const IntroSection = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          {/* Left Image */}
          <div className="lg:col-span-3">
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-96 lg:h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/54946970533212e6e33248d4f903af4c.jpg"
                alt="利用者が作業に集中している様子"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="lg:col-span-2 space-y-6">
            <p className="text-primary text-sm font-medium tracking-wider">（私たちについて）</p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-text-dark leading-tight">
              一人ひとりの<br />可能性を信じ、<br />共に歩む<strong>就労支援</strong>
            </h2>
            <div className="space-y-4 text-text-medium leading-relaxed">
              <p>
                おかやま就労支援事業所は、<strong>障害や病気</strong>を抱える方々が、自分らしく働くための支援を提供しています。
              </p>
              <p>
                私たちは、一人ひとりの個性や能力を大切にし、それぞれのペースに合わせた<strong>個別支援計画</strong>を作成します。<strong>職業訓練</strong>から<strong>就職活動</strong>、そして<strong>就職後のフォロー</strong>まで、一貫したサポート体制で皆様の「働きたい」という想いを実現します。
              </p>
              <p>
                岡山市北区という地域に根ざし、地域の企業や医療機関とも連携しながら、安心して働ける環境づくりに取り組んでいます。
              </p>
            </div>
            <div className="pt-4">
              <Link
                to="/services"
                className="inline-flex items-center text-primary font-medium hover:text-primary/70 transition-colors group"
              >
                事業内容を見る
                <i className="ri-arrow-right-line ml-2 text-lg group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
